import { BaseNodeCommand, NodeChangeRecord } from './base/BaseNodeCommand';

export class GroupNodesCommand extends BaseNodeCommand {
  private updates: Array<{ nodeId: string; groupPath: string[] }>;

  constructor(updates: Array<{ nodeId: string; groupPath: string[] }>) {
    super('Group', `Group ${updates.length} nodes`);
    this.updates = updates;
  }

  protected doExecute(): NodeChangeRecord[] {
    if (this.updates.length === 0) return [];
    const batch = this.updates.map(({ nodeId, groupPath }) => ({
      nodeId,
      changes: { attrs: { groupPath } }
    }));
    return (this.getMutationManager() as any).applyBatchNodeChanges(batch);
  }
}
